/**
 * This file is meant to host all the functions where there is an interaction with the SessionStorage API of the browser.
 */

/**
 * Clears session storage.
 */
export const clearSessionStorage = (): void => {
  sessionStorage.clear();
};

/**
 * Function to return the user name of the logged in user stored in the session storage.
 * @returns - User Name of the logged in user.
 */
export const getUserNameFromSessionStorage = (): string => {
  return sessionStorage.getItem('user_name') || '';
};

/**
 * Function to return the user name of the logged in user stored in the session storage.
 * @returns - User Name of the logged in user.
 */
export const getTokenFromSessionStorage = (): string => {
  return sessionStorage.getItem('token') || '';
};
